import { Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import BackButtonIcon from "./../../assets/svgs/BackButton.svg";
interface PageTitleProp {
  title: string;
}
const PageTitle: React.FC<PageTitleProp> = ({ title }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="active-page-header-container">
        <img
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          style={{ marginTop: "2px", cursor: "pointer",height:"32px",width:"auto",boxShadow:"0 2px 6px rgba(0, 0, 0, 0.08)",}}
          src={BackButtonIcon}
        />
        <Typography className="current-active-page-title">{title}</Typography>
      </div>
    </>
  );
};

export default PageTitle;
